module.exports = __webpack_public_path__ + "img/elevator-online.d042f610.png";